/*
 * <product-card-swatches>
 * Renders inside a product card. Clicking a swatch swaps the card's main image
 * to the chosen variant's photo and points the card's links at that variant.
 * Progressive enhancement: with no JS the swatches simply do nothing harmful,
 * and the card links still lead to the product page.
 */
if (!customElements.get('product-card-swatches')) {
  customElements.define(
    'product-card-swatches',
    class ProductCardSwatches extends HTMLElement {
      connectedCallback() {
        this.card = this.closest('.card-wrapper') || this.closest('product-component');
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        const swatch = event.target.closest('.card__swatch');
        if (!swatch || !this.card) return;
        event.preventDefault();

        const src = swatch.getAttribute('data-media-src');
        const srcset = swatch.getAttribute('data-media-srcset');
        const variantUrl = swatch.getAttribute('data-variant-url');

        // Swap the card's main image (first image inside the media wrapper).
        const image = this.card.querySelector('.card__media .media img');
        if (image && src) {
          if (srcset) image.setAttribute('srcset', srcset);
          image.setAttribute('src', src);
        }

        // Point the card links at the chosen variant so a click-through keeps the selection.
        if (variantUrl) {
          this.card
            .querySelectorAll('a.full-unstyled-link, a.card__heading, .card__heading a')
            .forEach((link) => link.setAttribute('href', variantUrl));
        }

        // Move the active state.
        this.querySelectorAll('.card__swatch--active').forEach((el) =>
          el.classList.remove('card__swatch--active')
        );
        swatch.classList.add('card__swatch--active');
      }
    }
  );
}
